import React from 'react';
import { components } from 'react-select';
import MaterialIcon from './MaterialIcon';
import styles from './styles.less';

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <MaterialIcon
        icon="keyboard_arrow_down"
        classOverride={styles.arrow_down}
      />
    </components.DropdownIndicator>
  );
};

export default DropdownIndicator;
